var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1C16.5228 1 21 5.47716 21 11C21 16.5228 16.5228 21 11 21C5.47716 21 1 16.5228 1 11C1 5.47716 5.47716 1 11 1Z",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8594 16.207C11.1348 16.207 11.3047 16.043 11.3047 15.7441V15.1172C12.7812 14.9707 13.6953 14.1035 13.6953 12.832C13.6953 11.7363 13.0508 11.0684 11.6387 10.7109L10.3262 10.377C9.58203 10.1836 9.18359 9.75586 9.18359 9.16406C9.18359 8.39648 9.82812 7.88672 10.8184 7.88672C11.5859 7.88672 12.0957 8.17383 12.6113 8.88281C12.8281 9.18164 12.957 9.26953 13.1562 9.26953C13.4141 9.26953 13.5781 9.09961 13.5781 8.83008C13.5781 8.51367 13.373 8.12695 13.0273 7.79883C12.6113 7.40039 12.0195 7.13672 11.3574 7.04883V6.46289C11.3574 6.16406 11.1816 6 10.9121 6C10.6367 6 10.4668 6.16406 10.4668 6.46289V7.02539C9.05469 7.14844 8.16406 7.99805 8.16406 9.2168C8.16406 10.2598 8.83203 11.0098 10.0391 11.3145L11.375 11.6543C12.2832 11.8887 12.6641 12.2578 12.6641 12.9023C12.6641 13.7461 12.0195 14.25 10.9238 14.25C10.0684 14.25 9.47656 13.9512 8.94336 13.2422C8.69141 12.9141 8.61523 12.8672 8.43945 12.8672C8.17578 12.8672 8 13.0488 8 13.3418C8 13.6816 8.22852 14.0742 8.62109 14.4023C9.07812 14.7832 9.71094 15.0293 10.4141 15.1055V15.7441C10.4141 16.043 10.5781 16.207 10.8594 16.207Z",
    fill: "#2F4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollarCircle);
export default __webpack_public_path__ + "static/media/IconDollarCircle.bf438e4ed881f71fb8698f370892572b.svg";
export { ForwardRef as ReactComponent };